import DOMPurify from 'dompurify'

// Notifications are authored by site admins as rich HTML (formatting, fonts, links, images, video).
// It is still rendered in other users' browsers, so every render goes through DOMPurify — a
// compromised admin account must not become stored XSS. Media + inline styles (fonts/colours/align)
// are allowed; scripts and event handlers are not.
const CONFIG = {
  ALLOWED_TAGS: [
    'p', 'br', 'span', 'div', 'strong', 'b', 'em', 'i', 'u', 's', 'sub', 'sup',
    'h1', 'h2', 'h3', 'blockquote', 'ul', 'ol', 'li', 'hr', 'pre', 'code',
    'a', 'img', 'video', 'source', 'iframe',
    'table', 'thead', 'tbody', 'tr', 'td', 'th',
  ],
  ALLOWED_ATTR: [
    'href', 'target', 'rel', 'src', 'alt', 'title', 'width', 'height', 'style', 'class',
    'controls', 'poster', 'type', 'colspan', 'rowspan',
    'allow', 'allowfullscreen', 'frameborder',
  ],
  // Links and media to known-safe schemes only.
  ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto):|[^a-z]|[a-z+.-]+(?:[^a-z+.\-:]|$))/i,
  ADD_ATTR: ['target'],
}

export function sanitizeHtml(html: string | null | undefined): string {
  if (!html) return ''
  return DOMPurify.sanitize(html, CONFIG) as unknown as string
}
